import Axios from 'axios'

const ENDPOINT = 'status'

export const STATUS_TYPE = {
    VISIBILITY: 'visibility_status',
    IDEA: 'status',
    LOCK: 'lock_status',
}

export const VISIBILITY_STATUS = {
    HIDDEN: 'hidden',
    PUBLISHED: 'published',
}

export const IDEA_STATUS = {
    OPEN: 'open',
    ACCEPTED: 'accepted',
    IMPLEMENTED: 'implemented',
    REJECTED: 'rejected',
}

export const LOCK_STATUS = {
    LOCKED: 'locked',
    UNLOCKED: 'unlocked',
}

/**
 * Put
 * @param {*} status_type
 * @param {*} idea_id
 */
export const patchObj = (status_type, idea_id, status) => {
    return new Promise((resolve, reject) => {
        Axios.patch(`/${ENDPOINT}/${status_type}/${idea_id}`, {
            status: status,
        })
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}
